module.exports = __webpack_public_path__ + "img/slider2.d854f7b4.png";